import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import { InfoIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PageHeaderInfoButtonProps } from './PageHeader.types';

/**
 * Optional info affordance that any identity part may append after its last
 * text element. Opens the page's "About" dialog.
 */
export function PageHeaderInfoButton(props: PageHeaderInfoButtonProps) {
  const { t } = useTranslation('common');
  const label = t('components.pageHeader.aboutPage', { page: props.page });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-mini"
          aria-label={label}
          onClick={props.onClick}
          data-testid="page-header-info-button"
        >
          <InfoIcon className="size-[14px] text-muted-foreground" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
